import { useQuery } from '@tanstack/react-query';

import { ordersApi } from '../api/orders-api';

import { orderKeys } from './order-keys';

/** Emails the store sent about the order; the worker sends them, so this lags the actions a little. */
export function useOrderNotifications(storeId: string, id: string) {
  return useQuery({
    queryKey: orderKeys.notifications(storeId, id),
    queryFn: () => ordersApi.notifications(storeId, id),
    select: (data) => data.items,
  });
}
